import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { T as TileGroupContextProvider } from '../TileGroupContext-CvSfRsxH.js';
import { F as Fieldset, C as Container, M as MessageWrapper } from './TileGroup.styles-BXHtPMdZ.js';
import { V as ValidationMessage } from '../../Input/ValidationMessage-B2QL8VMy.js';
import { T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

function TileGroup({
  children,
  numColumns,
  direction,
  disabled = false,
  message,
  statusType = 'error',
  id,
  multiple = false,
  name,
  onChange,
  selectedValues = [],
  taktId,
  taktValue,
  ...restProps
}) {
  const messageId = `${name}-${id}-tile-group-message`;
  const a11yProps = message ? {
    'aria-describedby': messageId,
    ...(statusType === 'error' ? {
      'aria-invalid': true
    } : {})
  } : {};
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('tile-group')
  }, /*#__PURE__*/React__default.createElement(TileGroupContextProvider, {
    direction: direction !== null && direction !== void 0 ? direction : 'column',
    disabled: disabled !== null && disabled !== void 0 ? disabled : false,
    multiple: multiple !== null && multiple !== void 0 ? multiple : false,
    name: name,
    onSelect: (value, event) => {
      if (onChange) {
        let values = [value];
        if (multiple) {
          const prevSelectedValues = [...(selectedValues !== null && selectedValues !== void 0 ? selectedValues : [])];
          const index = prevSelectedValues.indexOf(value);
          if (index !== -1) {
            values = [...prevSelectedValues.slice(0, index), ...prevSelectedValues.slice(index + 1)];
          } else {
            values = [...prevSelectedValues, value];
          }
        }
        onChange(values, event);
      }
    },
    selectedValues: selectedValues !== null && selectedValues !== void 0 ? selectedValues : []
  }, /*#__PURE__*/React__default.createElement(Fieldset, _extends({}, a11yProps, restProps, {
    disabled: disabled,
    id: id
  }), /*#__PURE__*/React__default.createElement(Container, {
    $numColumns: numColumns
  }, children), message && /*#__PURE__*/React__default.createElement(MessageWrapper, null, /*#__PURE__*/React__default.createElement(ValidationMessage, {
    value: "",
    messageId: messageId,
    message: message,
    statusType: statusType
  })))));
}

export { TileGroup as T };
//# sourceMappingURL=TileGroup-Bu3gDNRJ.js.map
